/**
 * Read-only client for the TPO Company Center landing page (DEV-3367). Rides the
 * ApplyForm backend through httpApplyApi (NOT the skynet gateway), matching the
 * native TPO Certification surfaces these cards summarize.
 */
export class CompanyCenterApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  // Single CompanyCenterSummaryDto with certification / decisioning / tasks /
  // ownersAndSigners for the SubCompany, powering every card on the page.
  async getCompanyCenterSummary({ subCompanyId }) {
    return this.#http.get(`/api/admin-panel/sub-companies/${subCompanyId}/company-center/summary`);
  }
}
